module.exports = __webpack_public_path__ + "static/media/cash-money.ff09554e.svg";